import { type DomainId, domains } from "../content/domains";

interface DomainSelectorProps {
  selected: DomainId[];
  onChange: (selected: DomainId[]) => void;
  otherText: string;
  onOtherTextChange: (value: string) => void;
}

export function DomainSelector({
  selected,
  onChange,
  otherText,
  onOtherTextChange,
}: DomainSelectorProps) {
  const toggle = (id: DomainId) => {
    onChange(selected.includes(id) ? selected.filter((d) => d !== id) : [...selected, id]);
  };

  const otherSelected = selected.includes("other");

  return (
    <div className="waitlist-form__group">
      <span className="label">Which roles do you interview for?</span>
      <div className="waitlist-form__chips">
        {domains.map((d) => {
          const isChecked = selected.includes(d.id);
          return (
            <label key={d.id} className={`checkbox${isChecked ? " checkbox--checked" : ""}`}>
              <input
                type="checkbox"
                checked={isChecked}
                onChange={() => toggle(d.id)}
                aria-label={d.label}
              />
              <span className="checkbox__dot" aria-hidden="true" />
              <span>{d.label}</span>
            </label>
          );
        })}
      </div>
      {otherSelected ? (
        <input
          type="text"
          className="input waitlist-form__row-other"
          placeholder="Tell us what you interview for"
          value={otherText}
          onChange={(e) => onOtherTextChange(e.target.value)}
          aria-label="Other domain"
        />
      ) : null}
    </div>
  );
}
